import { render } from "./EditTk.vue?vue&type=template&id=0b498d9c"
import script from "./EditTk.vue?vue&type=script&lang=js"
export * from "./EditTk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__